module.exports = __webpack_public_path__ + "media/auto_history/zmiana_rejestracji-db30639d.svg";